import React, { useEffect, useState, useMemo, useContext } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
    Button,
    Popover,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import GlobalContext from "../contexts/globalcontext";
import { Delete, Edit, Add } from "@mui/icons-material";
import BotTables from "../components/BotTables";
import { getTickerByCrypto, getOpenOrders } from "../api/apiCalls";
import PopperBot from "../components/PopperBot";
import fileData from "../data/bot";

const Bot = () => {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { sbAlert, setAuth, auth, setTotalOrders } =
        useContext(GlobalContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const [botArray, setBotArray] = useState([]);
    const [orders, setOrders] = useState([]);
    const [generatedTables, setGeneratedTables] = useState([]);
    const [popperTable, setPopperTable] = useState({});
    const [isAdd, setIsAdd] = useState(false);

    const saveToDatabase = async (data = null) => {
        // console.log(auth);
        try {
            const response = await axiosPrivate.post(
                `/data/bot/${auth.username}`,
                JSON.stringify(data || botArray)
            );
            // console.log(response);
            sbAlert(response.data.message, "success");
        } catch (err) {
            console.log(err);
            if (err.response?.status === 403) {
                setAuth({});
                navigate("/");
            }
        }
    };

    const getFromDatabase = async () => {
        try {
            const cOrders = await getOpenOrders();
            // console.log(cOrders);
            setOrders(cOrders);
            setTotalOrders(cOrders.length);
            const response = await axiosPrivate.get(
                `/data/bot/${auth.username}`
            );
            // console.log("data", response?.data[0]?.dbvalue);
            if (response?.data[0]?.dbvalue) {
                if (response?.data[0]?.dbvalue.length !== 0)
                    setBotArray(response?.data[0]?.dbvalue);
                else setBotArray(fileData);
            } else {
                setBotArray(fileData);
            }
            // sbAlert(response.data.message, "success");
        } catch (err) {
            console.log(err);
            if (err.response?.status === 403) {
                setAuth({});
                navigate("/");
            }
        }
    };

    const getPopperTable = (id) => {
        // console.log("id", id);
        const tableForPopper = botArray.find((item) => item.id === id);
        // console.log(tableForPopper);
        setPopperTable(tableForPopper);
    };
    const handleDelete = (id) => {
        // console.log("Handle Delete");
        let newArray = [];
        for (let i = 0; i < botArray.length; i++) {
            if (botArray[i].id !== id) {
                newArray.push(botArray[i]);
            }
        }
        setBotArray(newArray);
        saveToDatabase(newArray);
    };

    const handleEdit = (item) => {
        if (item.id === 0) {
            //Add to the list
            const newID = botArray[botArray.length - 1].id + 1;
            // console.log("newID", newID);
            item.id = newID;
            // console.log("Handle Edit", item);
            let newBotArray = botArray;
            newBotArray.push(item);
            // console.log("newBotArray", newBotArray);
            setBotArray(newBotArray);
            generateTradingTable();
        } else {
            //Update the botArray
            const newBotArray = botArray.map((row) => {
                if (row.id === item.id) return item;
                else return row;
            });
            setBotArray(newBotArray);
            // generateTradingTable();
        }
        setAnchorEl(null);
        saveToDatabase();
    };

    const generateTradingTable = useMemo(
        () => async () => {
            // console.log("generateTables", orders);
            // console.log("generateTables", botArray);
            let table = [];
            let tables = [];
            for (let i = 0; i < botArray.length; i++) {
                // first variables
                table = [];
                const brokerage = botArray[i].brokerage;
                const interval = botArray[i].interval;
                const profit = botArray[i].profit;
                const decimal = botArray[i].decimal;
                const dec_qty = botArray[i].decimal_qty;
                const buyQty = botArray[i].buyQty;
                const getQty = (botArray[i].buyQty * (1 - brokerage)).toFixed(
                    dec_qty
                );
                for (let j = 0; j < 15; j++) {
                    let row = {};
                    if (j === 0) {
                        row = {
                            buyPrice: botArray[i].price,
                            buyQty: buyQty.toFixed(dec_qty),
                            buyGetQty: getQty,
                            buyCost: (buyQty * botArray[i].price).toFixed(2),
                            sellPrice: (
                                botArray[i].price *
                                (1 + profit)
                            ).toFixed(decimal),
                            sellCost: (
                                (buyQty * botArray[i].price) /
                                (1 - brokerage)
                            ).toFixed(2),
                            sellQty: (
                                (buyQty * botArray[i].price) /
                                (1 - brokerage) /
                                (botArray[i].price * (1 + profit))
                            ).toFixed(dec_qty),
                            sellGetQty: (buyQty * botArray[i].price).toFixed(2),
                            buyQty2: (
                                (buyQty * botArray[i].price) /
                                (1 - brokerage) /
                                (botArray[i].price * (1 + profit)) /
                                (1 - brokerage)
                            ).toFixed(dec_qty),
                        };
                    } else {
                        const buyPrice = table[j - 1].buyPrice * (1 + interval);
                        const buyCost = buyPrice * buyQty;
                        const sellPrice = buyPrice * (1 + profit);
                        const sellCost = buyCost / (1 - brokerage);
                        const sellGetQty = buyCost;
                        const sellQty = sellCost / sellPrice;
                        const buyQty2 = sellQty / (1 - brokerage);
                        row = {
                            buyPrice: buyPrice.toFixed(decimal),
                            buyQty: buyQty.toFixed(dec_qty),
                            buyGetQty: getQty,
                            buyCost: buyCost.toFixed(2),
                            sellPrice: sellPrice.toFixed(decimal),
                            sellCost: sellCost.toFixed(2),
                            sellGetQty: sellGetQty.toFixed(2),
                            sellQty: sellQty.toFixed(dec_qty),
                            buyQty2: buyQty2.toFixed(dec_qty),
                        };
                    }
                    for (let z = 0; z < orders.length; z++) {
                        // Check Buy, Buy2 and Sell
                        if (orders[z].side === "SELL") {
                            //Check for Sell
                            if (
                                row.sellQty > orders[z].quantity * 0.998 &&
                                row.sellQty < orders[z].quantity * 1.002 &&
                                row.sellPrice > orders[z].price * 0.998 &&
                                row.sellPrice < orders[z].price * 1.002
                            ) {
                                row.sellStatus = true;
                                // console.log("row", row);
                            }
                        } else if (orders[z].side === "BUY") {
                            // check buy 1 and buy 2
                            if (
                                row.buyQty > orders[z].quantity * 0.998 &&
                                row.buyQty < orders[z].quantity * 1.002 &&
                                row.buyPrice > orders[z].price * 0.998 &&
                                row.buyPrice < orders[z].price * 1.002
                            ) {
                                row.buyStatus = true;
                                // console.log("row", row);
                            } else if (
                                row.buyQty2 > orders[z].quantity * 0.998 &&
                                row.buyQty2 < orders[z].quantity * 1.002 &&
                                row.buyPrice > orders[z].price * 0.998 &&
                                row.buyPrice < orders[z].price * 1.002
                            ) {
                                row.buy2Status = true;
                                // console.log("row", row);
                            }
                        }
                    }
                    table.push(row);
                    // console.log(table);
                }
                const res = await getTickerByCrypto(botArray[i].name);
                // console.log(res);
                // console.log(res[0]);

                tables.push({
                    table,
                    name: botArray[i].name,
                    front: botArray[i].name.split("_")[0],
                    back: botArray[i].name.split("_")[1],
                    currPrice: res[0].k,
                });
            }
            // console.log(tables);
            setGeneratedTables(tables);
        },
        [botArray]
    );

    useEffect(() => {
        // console.log("Load Data");
        getFromDatabase();
    }, []);

    useEffect(() => {
        generateTradingTable();
    }, [botArray]);

    // console.log("anchorEl", anchorEl);
    // console.log("Open", Boolean(anchorEl));
    return (
        <>
            <TableContainer component={Paper} sx={{ width: 1000 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Crypto</TableCell>
                            <TableCell align="center">Brokerage(%)</TableCell>
                            <TableCell align="center">Interval(%)</TableCell>
                            <TableCell align="center">Profit(%)</TableCell>
                            <TableCell align="right">Start Price</TableCell>
                            <TableCell align="center">Decimal</TableCell>
                            <TableCell align="center">Dec_Qty</TableCell>
                            <TableCell align="right">Buy Qty</TableCell>
                            <TableCell align="center" width={"150px"}>
                                <Button
                                    endIcon={<Add />}
                                    onClick={(e) => {
                                        setIsAdd(true);
                                        setAnchorEl(e.currentTarget);
                                    }}
                                >
                                    Action
                                </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {botArray.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                >
                                    {item.name}
                                </TableCell>
                                <TableCell align="center">
                                    {(item.brokerage * 100).toFixed(2)}%
                                </TableCell>
                                <TableCell align="center">
                                    {(item.interval * 100).toFixed(2)}%
                                </TableCell>
                                <TableCell align="center">
                                    {(item.profit * 100).toFixed(2)}%
                                </TableCell>
                                <TableCell align="right">
                                    {item.price}
                                </TableCell>
                                <TableCell align="center">
                                    {item.decimal}
                                </TableCell>
                                <TableCell align="center">
                                    {item.decimal_qty}
                                </TableCell>
                                <TableCell align="right">
                                    {item.buyQty}
                                </TableCell>
                                <TableCell
                                    align="center"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-evenly",
                                    }}
                                >
                                    <Button
                                        onClick={(e) => {
                                            setIsAdd(false);
                                            getPopperTable(item.id);
                                            setAnchorEl(e.currentTarget);
                                        }}
                                    >
                                        <Edit sx={{ width: "20px" }} />
                                    </Button>
                                    <Popover
                                        open={Boolean(anchorEl)}
                                        anchorEl={anchorEl}
                                        onClose={() => {
                                            setAnchorEl(null);
                                        }}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left",
                                        }}
                                        transformOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                        }}
                                    >
                                        <PopperBot
                                            botItem={isAdd ? null : popperTable}
                                            handleEdit={handleEdit}
                                        />
                                    </Popover>

                                    <Button>
                                        <Delete
                                            color="error"
                                            sx={{ width: "20px" }}
                                            onClick={() =>
                                                handleDelete(item.id)
                                            }
                                        />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <br />
            <Divider />
            <br />
            <BotTables tables={generatedTables} />
        </>
    );
};

export default Bot;
